<template>
    <div>
        <div style="text-align: right">
            <Button
                v-if="isLiquidation"
                :class="preCls + 'button-margin'"
                type="primary"
                ghost
                @click="onLiquidationClick"
            >
                查看{{ relContractId ? '换房' : '退房' }}清算
            </Button>
            <Button
                v-if="relContractId"
                :class="preCls + 'button-margin'"
                type="primary"
                ghost
                @click="toContractDetail(relContractId)"
            >
                查看新合同
            </Button>
            <Button
                v-if="oldContractId"
                :class="preCls + 'button-margin'"
                type="primary"
                ghost
                @click="toContractDetail(oldContractId)"
            >
                查看老合同
            </Button>

<!--            <Button-->
<!--                v-if="$can('updateCode') && isShowEditBtn"-->
<!--                :class="preCls + 'button-margin'"-->
<!--                type="primary"-->
<!--                ghost-->
<!--                @click="onClickUpdate"-->
<!--            >-->
<!--                修改合同编码-->
<!--            </Button>
暂时拿掉修改合同编码-->

            <Button
                v-if="$can('invalid') && isShowEditBtn"
                :class="preCls + 'button-margin'"
                type="error"
                ghost
                @click="onClickInvalid"
            >
                作废合同
            </Button>
            <Button
                v-if="$can('download')"
                :class="preCls + 'button-margin'"
                @click="onClickDownload"
                :disabled="this.info.entity.contractStatus === '27'"
            >
                下载合同
            </Button>
            <!-- <Button
                :class="preCls + 'button-margin'"
                @click="uploadAttachments"
            >
                上传合同附件
            </Button> -->
        </div>
        <Form ref="info" :labelWidth="120" viewonly>
            <!-- 合同信息 -->
            <contract-info
                prop="contract"
                v-model="info.entity"
                :type="5"
                justRead
                class="contract-content-class"
            />
            <Divider />
            <!-- 租客信息 -->
            <customer-info
                prop="cus"
                v-model="info.contractCus"
                justRead
                @popCus="popCus"
                :houseName="info.entity.houseName"
                :houseNo="info.entity.houseNo"
                :contractId="info.contractLease.contractId"
                :isShowEditBtn="isShowEditBtn"
            />
            <Divider />
            <!-- 租约信息 -->
            <lease-info
                prop="lease"
                v-model="info.contractLease"
                :selfFileName="selfFileName"
                justRead
                class="contract-content-class"
                @on-facility-update="changeFacility"
                @refresh-detail="refreshDetail"
            />
            <!-- 换房信息 -->
            <change-info
                v-model="info.changeInfo"
                v-if="info.changeInfo"
                class="contract-content-class"
                :text="info.entity.contractStatus === '8' ? '退租' : '换房'"
            />
        </Form>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showChangeContractInfo"
            title="修改合同编码"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="popCus"
        >
            <change-contract-info
                v-if="modal.showChangeContractInfo"
                :id="info.entity.id"
            >
            </change-contract-info>
        </smart-modal>
        <smart-modal
            v-model="modal.showUpload"
            title="上传合同附件"
            :width="800"
            :height="360"
            :maskClosable="false"
        >
            <c-upload-contract
                v-if="modal.showUpload"
                :id="info.entity.id"
                :ver="info.entity.ver"
            />
        </smart-modal>
        <!-- 弹出框-提示 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
        <!-- 提示信息——合同作废 -->
        <confirm
            :text="modalMsg"
            v-model="confirmShowInvalid"
            :id="curId"
            @closeModal="closeModalInvalid"
            @confirmModal="confirmModalInvalid"
        />
    </div>
</template>

<script>
import { ymd } from '_u/helper'

import ContractInfo from './children/contract-info'
import CustomerInfo from './children/customer-info'
import LeaseInfo from './children/lease-info'
import ChangeInfo from './children/change-info'
import cUploadContract from './c-upload-contract'
import Alter from '_v/components/alter'
import Confirm from '_v/components/confirm'
import {
    contractSave,
    contractInvalid,
    contractFacilityUpdate,
} from '@/api/contract'
import { fileDownload } from '@/api/sys-oss'
import { contractTplList } from '@/api/configuration'
import ChangeContractInfo from './children/change-contract-info'

export default {
    name: 'contractViewDetail',
    components: {
        ContractInfo,
        CustomerInfo,
        LeaseInfo,
        ChangeInfo,
        cUploadContract,
        Alter,
        Confirm,
        ChangeContractInfo,
    },
    props: {
        info: {
            type: Object,
            default: () => ({
                entity: {},
                facilityList: [],
                changeInfo: {},
                contractCus: {},
                contractLease: {},
            }),
        },
        // 新合同id
        relContractId: {
            type: String,
        },
        // 是否存在清算明细
        isLiquidation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            curId: '',
            modal: {
                showUpload: false,
                showChangeContractInfo: false,
            },
            contractTplList: [],
            modalMsg: '',
            alterShow: false,
            confirmShowInvalid: false,
            selfFileName: '',
        }
    },
    computed: {
        isShowEditBtn() {
            return (
                this.info.entity.contractStatus !== '9' &&
                this.info.entity.contractStatus !== '8'
            )
        },
        oldContractId() {
            return this.info.entity.sourceContractId
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            Promise.all([contractTplList({ pageNo: 1, pageSize: 999 })]).then(
                (args) => {
                    var [res] = args
                    this.contractTplList = res.data.page.list
                    // 附件文件下载名称——如果租客是个人、且证件类型是身份证、且身份证号码不为空，则身份证号码拼接到文件名称上
                    const cus = this.info.contractCus
                    const cusCredNo =
                        cus.cusType === '1' &&
                        cus.credType === '1' &&
                        cus.credNo
                            ? `-${cus.credNo}`
                            : ''
                    this.selfFileName = `${
                        this.info.entity.houseName
                    }${cusCredNo}-${ymd(this.info.entity.createTime)}`
                }
            )
        },
        // 下载合同
        onClickDownload() {
            contractSave(this.info.contractCus.contractId)
                .then((res) => {
                    const contract = this.contractTplList.find(
                        (v) => v.id === this.info.entity.contractTplId
                    )
                    let name = contract.tplName.split('.')[0]
                    name += `(${this.info.entity.houseNo})`
                    return fileDownload(res.data.fileId, `${name}.pdf`)
                })
                .then(() => {
                    this.$Message.success('下载成功')
                })
        },
        // 作废合同
        onClickInvalid() {
            // contractBillListCreate({ contractId: this.info.entity.id }).then(
            //     (res) => {
            //         const billList = res.data.page.list;
            //         let flag = true;
            //         billList.forEach((v) => {
            //             if (v.billStatus !== "5") {
            //                 flag = false;
            //             }
            //         });
            //         // 可以作废
            //         if (flag) {
            this.modalMsg = '作废后将自动同步作废相关账单，是否确定？'
            this.confirmShowInvalid = true
            this.curId = this.info.entity.id
            //     } else {
            //         this.modalMsg =
            //             "该合同下有已收账单未作废，无法作废合同";
            //         this.alterShow = true;
            //     }
            // }
            // );
        },
        // onClickUpdate
        onClickUpdate() {
            this.modal.showChangeContractInfo = true

            // contractBillListCreate({ contractId: this.info.entity.id }).then(
            //     (res) => {
            //         const billList = res.data.page.list;
            //         let flag = true;
            //         billList.forEach((v) => {
            //             if (v.billStatus !== "5") {
            //                 flag = false;
            //             }
            //         });
            //         // 可以修改
            //         if (flag) {
            //             this.$router.push({
            //                 name: "contractUpdate",
            //                 params: {
            //                     info: JSON.stringify(this.info),
            //                     from: "contractUpdate",
            //                 },
            //             });
            //         } else {
            //             this.modalMsg =
            //                 "该合同下有已收账单未作废，无法修改合同";
            //             this.alterShow = true;
            //         }
            //     }
            // );
        },
        // 查看清算明细
        onLiquidationClick() {
            this.$emit('show-liquidation')
        },
        // 上传合同附件
        uploadAttachments() {
            this.modal.showUpload = true
        },
        // 关闭 alter  closeModalInvalid
        closeAlter() {
            this.alterShow = false
        },
        closeModalInvalid() {
            this.confirmShowInvalid = false
        },
        confirmModalInvalid(id) {
            contractInvalid(id)
                .then(() => {
                    this.$Message.success('合同作废成功')
                    this.confirmShowInvalid = false
                })
                .finally(() => {
                    // 刷新页面
                    this.$emit('popCusTop')
                })
        },
        popCus() {
            console.log('popCusTop')
            this.$emit('popCusTop')
        },
        // 更新物品清单
        changeFacility(facility) {
            contractFacilityUpdate({
                facility,
                contractId: this.info.entity.id,
            }).then((res) => {
                this.$Message.success(this.$t('tips.update.success'))
            })
        },
        refreshDetail() {
            this.$emit('refresh-detail')
        },
        toContractDetail(id) {
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: id, type: '5' },
            })
        },
    },
}
</script>

<style></style>
